import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';
import ClassificationAlgorithmStatus from './ClassificationAlgorithmStatus';
import ClientRegistryStatus from './ClientRegistryStatus';

export default class DeviceTableDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.externalName = null;

		/** @type {number} */
		this.externalId = null;

		/** @type {string} */
		this.model = null;

		/** @type {string} */
		this.version = null;

		// /** @type {string} */
		// this.externalName = null;
		// /** @type {string} */
		// this.model = null;
		// /** @type {string} */
		// this.version = null;
		// /** @type {NamedDto} */
		// this.infrastructureElement = null;
		// /** @type {NamedDto} */
		// this.location = null;
		// /** @type {string} */
		// this.classificationAlgorithmStatus = null;
		// /** @type {NamedDto} */
		// this.project = null;
		// /** @type {string} */
		// this.registryStatus = null;
		// /** @type {number} */
		// this.externalId = null;

		/** @type {NamedDto} */
		this.project = null;

		/** @type {string} */
		this.location = null;

		/** @type {NamedDto} */
		this.deviceType = null;

		/** @type {Date} */
		this.lastSeen = null;

		/** @type {string} */
		this.registryStatus = null;

		/** @type {string} */
		this.status = null;

	}

	/**
	 * @typedef {Object} _DeviceTableDtoProps
	 * @property {string} externalName
	 * @property {string} model
	 * @property {string} version
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _DeviceTableDtoProps} DeviceTableDtoProps
	 */
	/**
	 *
	 * @param {DeviceTableDtoProps} props
	 * @returns {DeviceTableDto}
	 */
	setup(props) {
		super.setup(props);

		this.externalName = props.externalName;
		this.model = props.model;
		this.version = props.version;
		this.location = props.location;
		this.deviceType = props.deviceType !== null ? new NamedDto().setup(props.deviceType) : null;
		this.lastSeen = props.lastSeen != null ? new Date(props.lastSeen) : null;
		this.registryStatus = props.registryStatus;
		this.project = props.project !== null ? new NamedDto().setup(props.project) : null;
		this.status = props.status;
		// this.infrastructureElement = props.infrastructureElement !== null ? new NamedDto().setup(props.infrastructureElement) : null;
		// this.location = props.location !== null ? new NamedDto().setup(props.location) : null;
		// this.classificationAlgorithmStatus = props.classificationAlgorithmStatus;
		// this.project = props.project !== null ? new NamedDto().setup(props.project) : null;
		// this.registryStatus = props.registryStatus;
		// this.externalId = props.externalId;
		return this;
	}

	getAsString(key) {
		if (key === 'classificationAlgorithmStatus') {
			return this.classificationAlgorithmStatus != null ? ClassificationAlgorithmStatus[this.classificationAlgorithmStatus] : '';
		}
		/*if (key === 'registryStatus') {
			return this.registryStatus != null ? ClientRegistryStatus[this.registryStatus] : '';
		}*/

		return super.getAsString(key);
	}
}
